import {AppVersion} from '../../types/AppVersion';
import {AppFilterStrategy} from './AppFilterStrategy';

/**
 * Filter strategy for searching apps by text.
 * Searches in app display name and summary, matching all search terms (AND logic).
 */
export class SearchFilterStrategy extends AppFilterStrategy<string> {
  public matches(app: AppVersion, filterValue: string | undefined): boolean {
    if (!this.isActive(filterValue)) {
      return true;
    }

    const text = app.metadata.display_name + ' ' + app.metadata.summary;
    const searchTerms = filterValue!.toLocaleLowerCase().split(/\W/g);

    return searchTerms.every((term) => text.toLowerCase().includes(term));
  }
}
